import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Flag, Mountain, Users, Sprout, BookOpen, Vote, DollarSign, Heart, Shield, BarChart2, Briefcase, FileText, Crosshair } from 'lucide-react';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const trigatra = [{
  icon: Mountain,
  name: 'Geografi',
  score: 75,
  desc: 'Hotspot wilayah: Jawa, Sumatera Utara, Papua. Konsentrasi isu di pulau Jawa.'
}, {
  icon: Users,
  name: 'Demografi',
  score: 68,
  desc: 'Gen Z & Milenial dominan di TikTok, sebagian besar negatif. Kelompok rentan: petani, buruh, mahasiswa.'
}, {
  icon: Sprout,
  name: 'Sumber Daya',
  score: 52,
  desc: 'Isu pangan, BBM, energi, dan pupuk masih kritis. Komoditas strategis dalam tekanan opini.'
}];
const pancagatra = [{
  icon: BookOpen,
  name: 'Ideologi',
  score: 82,
  status: 'STABIL',
  color: 'emerald'
}, {
  icon: Vote,
  name: 'Politik',
  score: 65,
  status: 'WASPADA',
  color: 'amber'
}, {
  icon: DollarSign,
  name: 'Ekonomi',
  score: 45,
  status: 'KRITIS',
  color: 'red'
}, {
  icon: Heart,
  name: 'Sosial Budaya',
  score: 73,
  status: 'STABIL',
  color: 'emerald'
}, {
  icon: Shield,
  name: 'Hankam',
  score: 81,
  status: 'STABIL',
  color: 'emerald'
}];
const cardMap: Record<string, string> = {
  emerald: 'border-emerald-500/30 bg-emerald-500/5',
  amber: 'border-amber-500/30 bg-amber-500/5',
  red: 'border-red-500/30 bg-red-500/5'
};
const textMap: Record<string, string> = {
  emerald: 'text-emerald-500',
  amber: 'text-amber-500',
  red: 'text-red-500'
};
export function Astagatra() {
  const tg = Math.round(trigatra.reduce((a, b) => a + b.score, 0) / 3);
  const pg = Math.round(pancagatra.reduce((a, b) => a + b.score, 0) / 5);
  const nri = Math.round((tg + pg) / 2);
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1211">
      <PageHeader group="Stabilitas Nasional" title="Astagatra Digital Strategic Analysis" description="Analisis ketahanan nasional digital melalui Trigatra (geografi, demografi, SDA) dan Pancagatra (ideologi, politik, ekonomi, sosbud, hankam)." icon={Flag} data-id="element-1212" />

      <Card className="bg-card/50 border-border/50" data-id="element-1213">
        <CardContent className="p-6" data-id="element-1214">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-1215">
            <div className="text-center md:text-left" data-id="element-1216">
              <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground" data-id="element-1217">
                National Resilience Index (Digital)
              </p>
              <p className="font-heading text-6xl font-bold mt-2 text-amber-500" data-id="element-1218">
                {nri}
                <span className="text-2xl text-amber-500/60" data-id="element-1219">/100</span>
              </p>
              <p className="font-mono text-xs text-muted-foreground mt-2" data-id="element-1220">
                Komposit Trigatra + Pancagatra
              </p>
            </div>

            <div className="flex-1 max-w-md w-full" data-id="element-1221">
              <div className="mb-4" data-id="element-1222">
                <div className="flex justify-between font-mono text-[10px] mb-1" data-id="element-1223">
                  <span className="text-muted-foreground" data-id="element-1224">TRIGATRA</span>
                  <span className="text-blue-500" data-id="element-1225">{tg}/100</span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden" data-id="element-1226">
                  <div className="h-full bg-blue-500" style={{
                  width: `${tg}%`
                }} data-id="element-1227" />
                </div>
              </div>
              <div data-id="element-1228">
                <div className="flex justify-between font-mono text-[10px] mb-1" data-id="element-1229">
                  <span className="text-muted-foreground" data-id="element-1230">PANCAGATRA</span>
                  <span className="text-purple-500" data-id="element-1231">{pg}/100</span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden" data-id="element-1232">
                  <div className="h-full bg-purple-500" style={{
                  width: `${pg}%`
                }} data-id="element-1233" />
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <div data-id="element-1234">
        <h3 className="font-heading text-lg font-bold mb-3 flex items-center gap-2" data-id="element-1235">
          <span className="text-blue-500" data-id="element-1236">TRIGATRA</span>{' '}
          <span className="font-mono text-xs text-muted-foreground" data-id="element-1237">
            — Aspek Alamiah
          </span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1238">
          {trigatra.map(t => <Card key={t.name} className="bg-card/50 border-border/50" data-id="element-1239">
              <CardContent className="p-5" data-id="element-1240">
                <div className="flex items-center gap-3 mb-3" data-id="element-1241">
                  <div className="size-10 rounded bg-blue-500/10 border border-blue-500/30 flex items-center justify-center" data-id="element-1242">
                    <t.icon className="size-5 text-blue-500" data-id="element-1243" />
                  </div>
                  <div data-id="element-1244">
                    <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-1245">
                      Gatra
                    </p>
                    <h4 className="font-heading text-lg font-bold" data-id="element-1246">{t.name}</h4>
                  </div>
                </div>
                <p className="font-heading text-3xl font-bold text-blue-500" data-id="element-1247">
                  {t.score}
                  <span className="text-sm text-muted-foreground" data-id="element-1248">/100</span>
                </p>
                <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden mt-2 mb-3" data-id="element-1249">
                  <div className="h-full bg-blue-500" style={{
                width: `${t.score}%`
              }} data-id="element-1250" />
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed" data-id="element-1251">
                  {t.desc}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>

      <div data-id="element-1252">
        <h3 className="font-heading text-lg font-bold mb-3 flex items-center gap-2" data-id="element-1253">
          <span className="text-purple-500" data-id="element-1254">PANCAGATRA</span>{' '}
          <span className="font-mono text-xs text-muted-foreground" data-id="element-1255">
            — Aspek Sosial
          </span>
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-1256">
          {pancagatra.map(p => <Card key={p.name} className={`bg-card/50 border ${cardMap[p.color]}`} data-id="element-1257">
              <CardContent className="p-4 text-center" data-id="element-1258">
                <p.icon className={`size-6 mx-auto mb-2 ${textMap[p.color]}`} data-id="element-1259" />
                <p className="font-mono text-[9px] uppercase text-muted-foreground" data-id="element-1260">
                  {p.name}
                </p>
                <p className={`font-heading text-2xl font-bold mt-1 ${textMap[p.color]}`} data-id="element-1261">
                  {p.score}
                </p>
                <p className={`font-mono text-[9px] mt-1 ${textMap[p.color]}`} data-id="element-1262">
                  {p.status}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>

      <RelatedWorkflow currentStep="Astagatra Digital" nextSteps={[{
      to: '/ipoleksosbudhankam',
      icon: BarChart2,
      label: 'IPOLEKSOSBUDHANKAM',
      desc: 'Pilar stabilitas inti detail.'
    }, {
      to: '/command-tasking',
      icon: Briefcase,
      label: 'Tasking Lintas-K/L',
      desc: 'Koordinasi pilar yang melemah.'
    }, {
      to: '/war-room',
      icon: Crosshair,
      label: 'War Room',
      desc: 'Eskalasi ke pusat komando bila kritis.'
    }, {
      to: '/daily-brief',
      icon: FileText,
      label: 'Update Daily Brief',
      desc: 'Sertakan status Astagatra di brief Presiden.'
    }]} data-id="element-1263" />
    </div>;
}